import type { PdfComponentSignatureI } from '../typed';

const TermsAndConditionsRenderSignature: React.FunctionComponent<PdfComponentSignatureI> =
  function ({ signee, date, title, fingerprint, companyName }) {
    return (
      <div className="text-12-18 md:text-14-22 grid grid-cols-1 md:grid-cols-[min-content_auto] gap-1 md:gap-3">
        <span className="text-12-18-em md:text-14-22-em md:mt-auto">
          Signed:
        </span>
        <div className="w-full border-b border-neutral-900 min-h-7 md:min-h-10">
          <span className="text-24-28-em md:text-32-40-em font-[Scriptina]">
            {signee}
          </span>
        </div>
        <span className="text-12-18 md:text-14-22">By:</span>
        <div className="grid grid-cols-[min-content_auto] gap-x-1 md:gap-x-3 gap-y-1">
          <span>Name:</span>
          {signee ? (
            <span>{signee}</span>
          ) : (
            <div className="w-40 border-b border-neutral-900" />
          )}
          <span>Title:</span>
          {title ? (
            <span>{title}</span>
          ) : (
            <div className="w-40 border-b border-neutral-900" />
          )}
          <span>Date:</span>
          {date ? (
            <span>{date}</span>
          ) : (
            <div className="w-40 border-b border-neutral-900" />
          )}
          {fingerprint && (
            <>
              <span>Fingerprint:</span>
              <span>{fingerprint}</span>
            </>
          )}
        </div>
        <span className="col-span-1 md:col-span-2">
          Duly authorised for and on behalf of:{' '}
          {companyName ? <b>{companyName}</b> : ''}
        </span>
      </div>
    );
  };

export default TermsAndConditionsRenderSignature;
